import { cx } from "../../utils/classNames";
import Modal from "./Modal";
import ui from "./ui.module.css";

const ConfirmDialog = ({
  title,
  message,
  confirmLabel = "Confirm",
  tone = "primary", // "primary" | "danger"
  isPending = false,
  onConfirm,
  onClose,
}) => (
  <Modal
    title={title}
    onClose={onClose}
    footer={
      <>
        <button
          type="button"
          className={cx(ui.button, ui.secondary)}
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          type="button"
          className={cx(ui.button, tone === "danger" ? ui.danger : ui.primary)}
          onClick={onConfirm}
          disabled={isPending}
        >
          {isPending ? "Working…" : confirmLabel}
        </button>
      </>
    }
  >
    <p className="mb-0">{message}</p>
  </Modal>
);

export default ConfirmDialog;
